<template>
  <section class="content-blog">
    <Breadcrumb :links="links" />
    <div class="content-blog-itens">
      <div class="content-blog-itens-body">
        <div
          class="row content-blog-itens-body--category"
          v-for="category in categoriesWithPosts"
          :key="category.id_category"
        >
          <div
            class="w-100 d-flex items-center justify-content-between col-12 mb-4"
          >
            <h2 class="title--category">{{ category.category_name }}</h2>
          </div>
          <div
            class="col-12 col-sm-6 col-lg-4 col-xl-3"
            v-for="post in category.posts"
            :key="post.id_post"
          >
            <CardPost :post="post" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Index";
import CardPost from "@/views/Blog/components/CardPost";

export default {
  data() {
    return {
      objPost: {
        title: "Desenvolvimento",
        text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
        image: "image-post.png",
      },
      links: [
        {
          name: "Blog",
          routerName: "Blog",
        },
        {
          name: "Listar Posts",
          routerName: "ListPosts",
        },
        {
          name: "Categoria",
          routerName: "ListPostsByCategory",
        },
      ],
    };
  },
  components: {
    Breadcrumb,
    CardPost,
  },
  computed: {
    ...mapGetters({ categoriesWithPosts: "Blog/categoriesWithPosts" }),
  },
  methods: {
    ...mapActions("Blog", ["consultCategoriesWithPosts"]),
  },
  async mounted() {
    const payload = { id_category: this.$route.params.idCategory };
    await this.consultCategoriesWithPosts(payload);

    if (
      Array.isArray(this.categoriesWithPosts) &&
      this.categoriesWithPosts.length
    ) {
      this.links[2].name = this.categoriesWithPosts[0].category_name;
    }
  },
};
</script>

<style lang="scss">
.content-blog-itens-body--category {
  padding: 30px 0px;
  .title--category {
    font-size: 24px;
    font-family: "Font Bold";
    color: var(--black);
    text-align: left;
  }
  .btn-view-all {
    background: 0;
    border: 0;
    font-size: 24px;
    font-family: "Font Bold";
    color: var(--blue);
    text-transform: uppercase;
    margin-bottom: 0;
    @media (max-width: 991px) {
      font-size: 18px;
    }
  }
}
</style>
